import React from "react";

import l10n from "../../l10n/localization";
import Tabs from "react-toolbox/lib/tabs/Tabs";
import Tab from "react-toolbox/lib/tabs/Tab";
import FogForm from "../forms/FogForm";
import CostTable from "./cost/CostTable";
import * as utils from "../../utils/utils";
import CargoTableWrapper from "../cargo/CargoTableWrapper";
import CostInvoice from "./costInvoice/CostInvoice";
import {connect} from "react-redux";
import {Button} from "react-materialize";
import CostForm from "../forms/CostForm";
import * as creationActions from "../../actions/creation";
import FilesUpload from "./FilesUpload/FilesUpload";

class FogTabs extends React.Component {
    state = {
        activeTab: 0,
    };

    handleTabChange = (activeTab) => {
        this.setState({activeTab});
    };

    render() {

        let fog = null;
        let isNew = false;

        if ((!utils.notNullNorUndefined(this.props.item) || !utils.notNullNorUndefined(this.props.item.id)) && this.props.newlyCreatedElement === null) {
            isNew = true;
        } else {
            fog = {...this.props.item};

            if (this.props.newlyCreatedElement !== null) {
                fog = this.props.fogs.getById(this.props.newlyCreatedElement);
                if (!utils.notNullNorUndefined(fog)) {
                    isNew = true;
                } else if (utils.notNullNorUndefined(fog)) {
                    fog = fog.original;
                }
            }
        }

        /* Todo: /!\ L'onglet Cost/Invoice doit etre placé en dernier sous peine de casser les tabs situés après lui.   */
        return (
            <section className="fog-tabs">
                {!isNew && <h1>FOG #{fog.reference}{utils.notNullNorUndefined(fog.vessel) && " - " + fog.vessel.name}</h1>}
                {isNew && <h1>New FOG</h1>}
                <Tabs index={this.state.activeTab} onChange={this.handleTabChange}>
                    <Tab label={l10n.common.general}><FogForm item={fog} depth={this.props.depth} openDrawer={this.props.openDrawer} /></Tab>
                    <Tab label={l10n.common.cargoes} disabled={isNew}>{!isNew && <CargoTableWrapper fog={fog} depth={this.props.depth} openDrawer={this.props.openDrawer} />}</Tab>
                    <Tab label={l10n.fog.tab.filesUpload} disabled={isNew}>
                        {!isNew &&
                        <div className="files-upload-tab">
                            <FilesUpload fog={fog} depth={this.props.depth} openDrawer={this.props.openDrawer} currency={utils.notNullNorUndefined(fog.currency) ? fog.currency.isoCode : ''}/>
                        </div>
                        }
                    </Tab>
                    <Tab label={l10n.common.costs} disabled={isNew}>{!isNew &&
                        <div className="cost-tab">
                            <CostTable fog={fog} depth={this.props.depth} openDrawer={this.props.openDrawer} currency={utils.notNullNorUndefined(fog.currency) ? fog.currency.isoCode : ''}/>
                            <br />
                            <i className="left-align">
                                <Button type="button" floating onClick={() => this.props.openDrawer(CostForm, {item: null, fog: fog}, creationActions.destroyingnewlyCreatedCost())} icon="add" className="add-button"/>
                            </i>
                        </div>
                    }</Tab>
                    <Tab label={l10n.fog.costInvoice} disabled={isNew}>{!isNew && this.state.activeTab === 4 && <CostInvoice fog={fog} depth={this.props.depth} openDrawer={this.props.openDrawer} currency={utils.notNullNorUndefined(fog.currency) ? fog.currency.isoCode : ''}/>}</Tab>
                </Tabs>
            </section>
        )
    }
};

export default connect((state) => {
    return Object.assign({}, {
        newlyCreatedElement: state.creation.newlyCreatedFog,
        fogs: state.fog.fogs,
    });
})(FogTabs);


/* {(!isNew && (this.state.activeTab === 4)) && <FilesUpload fog={fog} depth={this.props.depth} openDrawer={this.props.openDrawer} /> } */


// WEBPACK FOOTER //
// ./src/components/fog/FogTabs.js